// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:30Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro timestamp_Level.
 */
enum EnumTimestampLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED'
};
export default EnumTimestampLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumTimestampLevel.QUALIFIED]: {caption: ''},
    [EnumTimestampLevel.GUARANTEED]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
